import { AulaEditor } from '@ublend-npm/aula-editor';
import withFileBlocksValidation from './withFileBlocksValidation';
import withAnalytics from './withAnalytics';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import withFileScanFromRedux from './withFileScanFromRedux';

const AulaEditorWithValidation = withAnalytics(
  withFileBlocksValidation(AulaEditor)
);

export default withErrorBoundary(
  withFileScanFromRedux(AulaEditorWithValidation),
  {
    ignore: true,
  }
);
